import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Card, CardContent } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import VendorRep from "./VendorRep/VendorRep";

import InventoSum from "./InventoSum/InventoSum";
import InventoVal from "./InventoVal/InventoVal";
import PurOrder from "./PurOrder/PurOrder";

const StyledTabs = styled((props) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  "& .MuiTabs-indicator": {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
  },
  "& .MuiTabs-indicatorSpan": {
    maxWidth: 40,
    width: "100%",
    backgroundColor: "#1d82f5",
  },
});

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    color: "#C0B476",
    "&.Mui-selected": {
      color: "#000000",
    },
    "&.Mui-focusVisible": {
      backgroundColor: "red",
    },
  })
);

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function MainReportAsset() {
  const [value, setValue] = React.useState(0);
  const navigate = useNavigate();
  const handleChange = (event, newValue) => {
    if (newValue === 1) {
      navigate("?tab=order-report");
    }
    if (newValue === 2) {
      navigate("?tab=inventory-summary");
    }
    if (newValue === 3) {
      navigate("?tab=inventory-valuation-summary");
    }
    if (newValue === 0) {
      navigate("?tab=vendor-report");
    }
    setValue(newValue);
  };

  return (
    <Card sx={{ backgroundColor: "white" }}>
      <CardContent>
        <Box
          sx={{
            maxWidth: "100%",
          }}
        >
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              background: "white",
            }}
          >
            <StyledTabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <StyledTab label="Vendor Report" {...a11yProps(0)} />
              <StyledTab label="Purchase Order Report" {...a11yProps(1)} />
              <StyledTab label="Inventory Summary" {...a11yProps(2)} />
              <StyledTab
                label="Inventory Valuation Summary"
                {...a11yProps(3)}
              />
            </StyledTabs>
          </Box>

          <CustomTabPanel value={value} index={0}>
            <VendorRep />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <PurOrder />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <InventoSum />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={3}>
            <InventoVal />
          </CustomTabPanel>
        </Box>
      </CardContent>
    </Card>
  );
}
